import { useCMSApiQuery } from '../../hooks/useCMSApiQuery';

export function useFooterColumns(locale: string) {
  return useCMSApiQuery<GetFootersResponseTO>('/cms/v1/footers', {
    culture: locale,
  });
}

type GetFootersResponseTO = {
  footers: FooterColumnTO;
};

type FooterColumnTO = {
  footerColumn: {
    linkText: string | null;
    linkUrl: string | null;
    links: LinkTO[];
    name: string;
    openInNewWindow: boolean;
  };
};

type LinkTO = {
  email: string;
  iconImage: string;
  iconValueType: string;
  linkText: string;
  linkType: string;
  linkUrl: string;
  mobile: string;
  name: string;
  openInNewWindow: boolean;
};
